<template>
    <BaseForm>
        <template #fields>
            <TextField
                :value="values.responsible"
                :label="$t('responsible')"
                :error-messages="errors.responsible"
                @input="setFieldValue('responsible', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('responsible', true)"
            />
            <TextField
                :value="values.assistant"
                :label="$t('assistant')"
                :error-messages="errors.assistant"
                @input="setFieldValue('assistant', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('assistant', true)"
            />
            <TextAreaField
                :value="values.teamChanges"
                :label="$t('team-changes')"
                :error-messages="errors.teamChanges"
                :max-length="EventTeamStructureSchema.shape.teamChanges.maxLength ?? undefined"
                @input="setFieldValue('teamChanges', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('teamChanges', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import TextField from '@/components/Form/TextField.vue';
import { useEventInjection } from '@/event/composables/useEventInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventTeamStructureSchema } from '../schemas';

const props = defineProps<{ eventId: string }>();
const eventId = computed(() => props.eventId);
const { event, updateEvent } = useEventInjection();

const { errors, values, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    EventTeamStructureSchema,
    computed(() => ({
        responsible: event.value?.responsible ?? '',
        assistant: event.value?.assistant ?? '',
        teamChanges: event.value?.teamChanges ?? '',
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateEvent({ id: eventId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
